module.exports = __webpack_public_path__ + "static/media/LeftArrow.bf38a968.svg";